import React, { useEffect, useState } from "react";
import "../../src/Css/Sectionone.css";
const SectionOne = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://api.gkaglobal.org/gkawebsite/welcome.php"
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const contentType = response.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
          throw new Error("Received non-JSON response");
        }

        const result = await response.json();
        setData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="custom-div">
      <h1>{data?.header || "No Header Available"}</h1>
      <ul style={{ textAlign: "justify" }}>
        {Array.isArray(data?.content) && data.content.length > 0 ? (
          data.content.map((item, index) => (
            <li key={index} style={{ textAlign: "justify" }}>
              {typeof item === "object" && item.sentence ? (
                <>
                  {item.sentence.split(/<b>(.*?)<\/b>/g).map((part, idx) => {
                    if (idx % 2 === 1) {
                      return (
                        <span key={idx} style={{ fontWeight: "bold" }}>
                          {part}
                        </span>
                      );
                    }

                    return part;
                  })}
                </>
              ) : (
                JSON.stringify(item)
              )}
            </li>
          ))
        ) : (
          <p>No Content Available</p>
        )}
      </ul>
    </div>
  );
};

export default SectionOne;
